import React from 'react';
import { openAssistant } from '../pages/Chat';

function Header() {
    return (
        <header className="site-header">
            <a className="brand-link" href="#top" aria-label="Chase AI home">
                <span className="logo-name"></span>
            </a>
            <nav className="site-nav" aria-label="Primary navigation">
                <a href="#services">Services</a>
                <a href="#about">About</a>
                <a href="#process">Process</a>
                <button className="nav-cta" type="button" onClick={openAssistant}>
                    Contact
                </button>
            </nav>
        </header>
    );
}

export default Header;
